import createIcon from '../../createIcon';

/**
 * @component @name SwipeRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuOTggMTYuODJMMTkuMzUgMjEuMjhDMTkuMjEgMjIuMjcgMTguMzYgMjMgMTcuMzcgMjNIMTEuMjFDMTAuNjggMjMgOS45MiAyMi43OSA5LjU1IDIyLjQxTDUgMTcuNjJMNS44MyAxNi43OEM2LjA3IDE2LjU0IDYuNDEgMTYuNDMgNi43NSAxNi41TDEwIDE3LjI0VjYuNUMxMCA1LjY3IDEwLjY3IDUgMTEuNSA1QzEyLjMzIDUgMTMgNS42NyAxMyA2LjVWMTIuNUgxMy45MUMxNC4yMiAxMi41IDE0LjUzIDEyLjU3IDE0LjggMTIuNzFMMTguODkgMTQuNzVDMTkuNjYgMTUuMTQgMjAuMSAxNS45NyAxOS45OCAxNi44MlpNMTkuOTEgNS41SDE3VjdIMjJWMkgyMC41VjQuMDJDMTguMTggMi4xMyAxNS4yMiAxIDEyIDFDNi41MSAxIDIuNzMgNC4xMiAyIDdIMy41N0M0LjMzIDUuMDIgNy4yNiAyLjUgMTIgMi41QzE1LjAzIDIuNSAxNy43OSAzLjY0IDE5LjkxIDUuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwipeRight = createIcon('SwipeRight', [
  [
    'path',
    {
      d: 'M19.98 16.82L19.35 21.28C19.21 22.27 18.36 23 17.37 23H11.21C10.68 23 9.92 22.79 9.55 22.41L5 17.62L5.83 16.78C6.07 16.54 6.41 16.43 6.75 16.5L10 17.24V6.5C10 5.67 10.67 5 11.5 5C12.33 5 13 5.67 13 6.5V12.5H13.91C14.22 12.5 14.53 12.57 14.8 12.71L18.89 14.75C19.66 15.14 20.1 15.97 19.98 16.82ZM19.91 5.5H17V7H22V2H20.5V4.02C18.18 2.13 15.22 1 12 1C6.51 1 2.73 4.12 2 7H3.57C4.33 5.02 7.26 2.5 12 2.5C15.03 2.5 17.79 3.64 19.91 5.5Z',
      key: 'yc9wbe',
    },
  ],
]);

export default SwipeRight;
